(() => {
  if (window.OztechImageViewer) return;

  let dialog;
  let viewerImage;
  let lastTrigger;

  const buildViewer = () => {
    if (dialog?.isConnected) return dialog;

    dialog = document.createElement('dialog');
    dialog.className = 'oz-image-viewer';
    dialog.setAttribute('aria-label', 'Expanded product image');
    dialog.innerHTML = `
      <button class="oz-image-viewer__close" type="button" aria-label="Close image viewer">×</button>
      <div class="oz-image-viewer__stage">
        <img class="oz-image-viewer__image" alt="">
      </div>
    `;

    viewerImage = dialog.querySelector('.oz-image-viewer__image');
    dialog.querySelector('.oz-image-viewer__close').addEventListener('click', close);
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog || event.target.classList.contains('oz-image-viewer__stage')) close();
    });
    dialog.addEventListener('cancel', (event) => {
      event.preventDefault();
      close();
    });
    dialog.addEventListener('close', finishClose);
    document.body.append(dialog);
    return dialog;
  };

  const open = (trigger) => {
    const fullUrl = trigger.dataset.ozImageFull;
    if (!fullUrl) return;

    const sourceImage = trigger.matches('img') ? trigger : trigger.querySelector('img');
    lastTrigger = trigger;
    buildViewer();
    viewerImage.alt = sourceImage?.alt || '';
    viewerImage.src = fullUrl;
    document.documentElement.classList.add('oz-image-viewer-open');
    dialog.showModal();
    dialog.querySelector('.oz-image-viewer__close').focus({ preventScroll: true });
  };

  function finishClose() {
    document.documentElement.classList.remove('oz-image-viewer-open');
    viewerImage?.removeAttribute('src');
    viewerImage?.removeAttribute('srcset');
    if (lastTrigger?.isConnected) lastTrigger.focus({ preventScroll: true });
    lastTrigger = null;
  }

  function close() {
    if (!dialog?.open) return;
    dialog.close();
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-oz-image-viewer-trigger]');
    if (!trigger) return;
    event.preventDefault();
    event.stopPropagation();
    open(trigger);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && dialog?.open) {
      event.preventDefault();
      close();
      return;
    }

    if (event.key !== 'Enter' && event.key !== ' ') return;
    const trigger = event.target.closest('[data-oz-image-viewer-trigger]');
    if (!trigger) return;
    event.preventDefault();
    event.stopPropagation();
    open(trigger);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    if (lastTrigger && event.target.contains(lastTrigger)) close();
  });

  window.OztechImageViewer = { open, close };
})();
